<template>
  <section
    class="listing-lavorazioni--gallery">
    <div class="zmm-gallery__arrows listing-lavorazioni--gallery__zmm-gallery__arrows">
      <div
        class="zmm-gallery__arrows__prev"
        @click="$_swipeRight">
          <svg width="24px" height="29px" viewBox="0 0 24 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g id="DESKTOP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                  <g class="svg-arrow" transform="translate(-1579.000000, -1803.000000)" stroke-width="2">
                      <path d="M1580,1804.77251 L1580,1830.22749 L1601.0662,1817.5 L1580,1804.77251 Z" id="Rectangle-Copy" transform="translate(1591.000000, 1817.500000) scale(-1, 1) translate(-1591.000000, -1817.500000) "></path>
                  </g>
              </g>
          </svg>
      </div>
      <div
        class="zmm-gallery__arrows__next"
        @click="$_swipeLeft">
          <svg width="24px" height="29px" viewBox="0 0 24 29" version="1.1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
            <g id="DESKTOP" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
                <g class="svg-arrow" transform="translate(-1628.000000, -1803.000000)" stroke-width="2">
                    <path d="M1629,1804.77251 L1629,1830.22749 L1650.0662,1817.5 L1629,1804.77251 Z" id="Rectangle"></path>
                </g>
            </g>
          </svg>
      </div>
    </div>
    <ul
      v-slider-swipe="{ left: $_swipeLeft, right: $_swipeRight, active: true, desktopSize: '640' }"
      ref="elements">
      <li
        v-for="(section, index) of hydratedListing"
        v-animate-on-intersection
        :key="index">
        <router-link :to="{ name: `${lang}-lavorazioni-sub`, params: { type: section.slug } }">
          <picture>
            <source :srcset="imgServer + section.images.mobile" media="(max-width: 639px)">
            <source :srcset="imgServer + section.images.desktop" media="(min-width: 640px)">
            <img :src="imgServer + section.images.desktop" :alt="section.title">
          </picture>
          <div class="listing-lavorazioni__content hide-for-medium">
            <div class="default-container">
              <h3 v-html="section.title"></h3>
            </div>
          </div>
          <div class="listing-lavorazioni__content--desktop show-for-medium">
            <img src="/lavorazioni/hover-poligono.svg">
            <span>0{{ index + 1 }}</span>
            <h4 v-html="section.title"></h4>
          </div>
        </router-link>
      </li>
    </ul>
  </section>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import Hammer from 'hammerjs'

export default {
  data: () => ({
    loading: true,
    ended: false,
    currentSlide: 1,
    elementsCount: 0,
    swiping: false
  }),
  props: {
    list: {
      type: Array,
      default: () => []
    },
    lang: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters([
      'processingsExcerpts'
    ]),
    hydratedListing: {
      get () {
        return this.processingsExcerpts(this.lang)
      }
    },
    imgServer: {
      get () {
        return process.env.VUE_APP_ENDPOINT
      }
    }
  },
  methods: {
    ...mapActions([
      'loadProcessingsExcerpts'
    ]),
    $_scrollTo (element, elementsCount, index, scroll = true) {
      this.currentSlide = index
      this.elementsCount = elementsCount

      if (!scroll) return
      const parentNode = element.parentNode
      parentNode.scrollTo({
        top: 0,
        left: (this.currentSlide <= 1) ? 0 : element.offsetLeft - (parentNode.offsetWidth / 2 - element.offsetWidth / 2),
        behavior: 'smooth'
      })
    },
    $_swipeLeft () {
      this.swiping = true
      window.requestAnimationFrame(() => { this.swiping = false })
      const elements = Array.prototype.slice.call(this.$refs.elements.children)
      const currentElement = elements[this.currentSlide + 2]
      if (typeof currentElement !== 'undefined') this.$_scrollTo(currentElement, elements.length, this.currentSlide + 2)
    },
    $_swipeRight () {
      this.swiping = true
      window.requestAnimationFrame(() => { this.swiping = false })
      const elements = Array.prototype.slice.call(this.$refs.elements.children)
      const currentElement = elements[this.currentSlide - 2]
      if (typeof currentElement !== 'undefined') this.$_scrollTo(currentElement, elements.length, this.currentSlide - 2)
    }
  },
  directives: {
    'slider-swipe': {
      bind (el, binding, vnode) {
        // if (!binding.value.active) return
        if (window.matchMedia('(max-width: 640px)').matches) {
          return
        }
        const manager = new Hammer.Manager(el)
        const swipe = new Hammer.Swipe()
        manager.add(swipe)
        manager.on('swipeleft', binding.value.left)
        manager.on('swiperight', binding.value.right)
      }
    }
  },
  watch: {
    list: {
      async handler (list) {
        this.loading = true
        await this.loadProcessingsExcerpts({
          lang: this.lang,
          filter: list
        })
        this.loading = false
      },
      immediate: true
    }
  }
}
</script>

<style lang="scss">
  @import "../assets/mixins/breakpoints";
  @import "../assets/mixins/typo";

  .zmm-gallery__arrows.listing-lavorazioni--gallery__zmm-gallery__arrows{
    display: none;
    @media #{$medium_mq} {
      display: block;
    }
  }

  .listing-lavorazioni--gallery{
    overflow: hidden;

    ul {
      display: flex;
      flex-direction: column;
      flex-wrap: wrap;
      overflow: visible;

      @media #{$medium_mq} {
        flex-direction: row;
        overflow: hidden;
        flex-wrap: nowrap;
      }

    }

    li{
      display: block;
      width: 100%;
      width: auto;

      @media #{$medium_mq} {
        &:before{
          content: "";
          position: absolute;
          left:0;
          top: 0;
          right: 0;
          bottom: 0;
          background-color: rgba(255, 255, 255, .8);
          z-index: 10;
          transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
        }

        &:hover:before {
          background-color: rgba(255, 255, 255, 0);
        }

      }

    }

    a{
      display: block;
      text-decoration: none;
    }

    picture img{
      display: block;
      width: 100%;
      height: auto;

      @media #{$medium_mq} {
        width: 38vw;
        height: auto;
        max-width: 443px;
      }
      @media #{$large_mq} {
        width: 30vw;
        height: auto;
      }
      @media #{$xlarge_mq} {
        width: 28vw;
        height: auto;
      }
      @media #{$xxlarge_mq} {
        width: 25vw;
        height: auto;
      }

    }

    .listing-lavorazioni__content{
      position: absolute;
      top: 50%;
      transform: translate3d(0, -50%, 0);

      h3{
        font-size: 1.6rem;
        color: #EFEFF1;
        margin: 0 0 0;
        line-height: 1.2;
        padding: 1rem 0;
        text-transform: uppercase;
        letter-spacing: .25rem;
        @media #{$medium_mq} {
          font-size: 2.3rem;
        }
        @media #{$large_mq} {
          font-size: 2.5rem;
        }
      }

      p{
        font-size: 1.6rem;
        line-height: 1;
        color: #9B9B9B;
        line-height: 1.4;
      }

    }

    .listing-lavorazioni__content--desktop{
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 1rem;
      z-index: 20;
      padding: 1rem 2rem 0;

      @media #{$medium_mq} {
        padding: 1rem 1.7rem 0;
      }
      @media #{$large_mq} {
        padding: 1rem 2rem 0;
      }
      @media #{$xlarge_mq} {
        padding: 1rem 3rem 0;
      }

      img{
        position: absolute;
        left: 0; top: 0;
        width: 100%;
        transform: translate3d(0, -100%, 0);
        transition: all 400ms cubic-bezier(0.23, 1, 0.32, 1);
      }

      &:hover img{
        transform: translate3d(0, 0, 0);
      }

      span{
        font-size: 8.6rem;
        line-height: 1;
        margin-bottom: 1rem;
        color: #4A4A4A;
        display: block;
        font-family: 'Sectra', sans-serif;
        font-weight: 300;

        @media #{$large_mq} {
          font-size: 10rem;
        }

        @media #{$xlarge_mq} {
          font-size: 11.15rem;
        }
      }
      h4{
        color: #4A4A4A;
        @include size-16-pixel(#4A4A4A);
        letter-spacing: .1rem;
        line-height: 1.3;
        text-transform: uppercase;
        font-family: 'Roboto', sans-serif;
        font-weight: 500;
      }
    }

  }

</style>
